module.exports = __webpack_public_path__ + "static/img/4.3aaad71.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/3/zh/4.png
// module id = 4Sj0
// module chunks = 0